import React from 'react';
import FlowRendererField from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererField';

/* Utilities */
import { trans } from 'js/utilities';

export default function ConversionFlowComponentShortLeaseCalculator({ component, path, id, ...passProps }) {
    const PriceFormat = Intl.NumberFormat(
        'nl-NL',
        {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }
    );

    return (
        <div className="col-12">
            <div className="conversion-flow__finance-calculator">
                <div className="row gutters-x-4 gutters-y-4">
                    <FlowRendererField
                        component={component}
                        fields={component?.fields}
                        path={`${path}.fields`}
                        id={`${id}.fields`}
                        {...passProps}
                    />
                    <div className="col-12">
                        <div className="price-per-month">
                            <p className="text--14 text--xl-16 mb-0">
                                {trans('flow.finance.price_per_month')}
                            </p>
                            <p className="mb-1 text-right text-md-left text-base text--22 font-weight-extra-bold">
                                {PriceFormat.format(component.metadata.price_per_month)}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
